import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';

@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.scss']
})
export class FeaturesComponent implements OnInit {

  constructor(private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService
  ) { }


  ngOnInit() {
    this.titleService.setTitle('產品特色-Trinka高級學術和技術寫作工具');
    this.metaTagService.updateTag({ name: 'description', content: 'Trinka旨在使學術和技術寫作變得輕鬆自如，能增強了您作品的語調，風格和結構，達到出版要求。' });
    this.metaTagService.updateTag({ name: 'keywords', content: '高級文法檢查，高級拼寫檢查，句子更正，句子結構檢查工具，科學語調，格式指南' });
    this.metaTagService.updateTag({ property: 'og:title', content: '產品特色-Trinka高級學術和技術寫作工具' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'Trinka旨在使學術和技術寫作變得輕鬆自如，能增強了您作品的語調，風格和結構，達到出版要求。' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/features' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'zh-tw' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/features' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/features' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/features' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/features' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/features' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/features' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/features' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/features' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/features' });
  }

}
